import KpiCard from "@/components/KpiCard.vue";
import PercentageValue from "@/components/tableElements/PercentageValue.vue";
import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
import NumberValue from "@/components/tableElements/NumberValue.vue";
import { getDescriptionBasedOnKpiKey } from "@/utils/transformers";
import { COLORS } from "@/utils/constants";
const {
  title,
  detail
} = getDescriptionBasedOnKpiKey("spend");
export default {
  name: "SpendCard",
  props: {
    amount: {
      type: Number
    },
    subtitleAmount: {
      type: Number
    },
    percentage: {
      type: Number
    },
    percentageColor: {
      type: String
    },
    percentageBgColor: {
      type: String
    },
    subtitlePercentage: {
      type: [Number, null]
    },
    loading: {
      type: Boolean
    }
  },
  components: {
    KpiCard,
    PercentageValue,
    CurrencyValue,
    NumberValue
  },
  data() {
    return {
      COLORS,
      title,
      detail
    };
  }
};